writeWithErrors